import { styled, Box, Grid2 } from '@mui/material';

export const DashboardCard = styled(Box)`
    /* min-width: 365.33px; */
    height: 176px;
    border-radius: 12px;
    border-width: 1px;
    border-style: solid;
    overflow: hidden;
    border-color: #e0e0e0;
    gap: 24px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.4);
`;
